/* istanbul ignore file */
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import React from 'react';
import './user-is-typing.less';

export default function UserIsTyping() {
    return (
        <div className="user-is-typing">
            <LoadingOverlay/>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/components/user-is-typing.js